module.exports = __webpack_public_path__ + "img/FullBackRed.a11bf23b.jpg";